import React, { useRef } from 'react';
import { useState } from 'react';
// @ts-ignore
import moment from 'moment';
import Modal from '../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { Size } from '../../../../Enums/Size.enum';
import HealthPlanLaboratoryExam from './HealthPlanLaboratoryExam';

interface HealthPlanLaboratoryExamModalProps {
	opened: boolean;
	onClose: any;
	disableSubmit?: boolean;
}

export default function HealthPlanLaboratoryExamModal(
	props: HealthPlanLaboratoryExamModalProps,
) {
	const { opened, onClose, disableSubmit } = props;
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={opened} onClose={onClose} wrapChat={isCase} size={Size.XL}>
			<Modal.Header title={'component.healthPlan.item.laboratoryExamination'} />
			<Modal.Content contentScroll={true}>
				<HealthPlanLaboratoryExam
					onSuccess={onClose}
					disableSubmit={disableSubmit}
				/>
			</Modal.Content>
		</Modal>
	);
}
